import React,{useEffect} from 'react';
import Cal,{getCalApi} from "@calcom/embed-react";
import {FadeIn} from './ui/FadeIn';

export function BookCall() {
  useEffect(()=> {
    (async function () {
      const cal=await getCalApi({"namespace":"30min"});
      cal("ui",{"theme": "dark","hideEventTypeDetails": false,"layout": "month_view"});
    })();
  },[]);

  return (
    <section id="book" className="py-section-mob md:py-section-desk bg-paper border-t border-hairline">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <h2 className="font-heading text-h2-mob md:text-h2-desk text-ink mb-12 md:mb-16"> Let's talk for 30 minutes. </h2>
        </FadeIn>
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">
          <div className="lg:w-[40%]">
            <FadeIn delay={0.1}>
              <p className="font-body text-body-lg text-ink mb-12"> No slides. No pitch. Just a real conversation about what you're trying to build and whether I can help. If the answer is yes, I'll tell you how. If the answer is no, I'll tell you that too, and point you to someone better suited if I can. </p>
              <div className="font-mono text-caption text-graphite uppercase space-y-2">
                <p>30 MINUTES</p>
                <p>VIDEO CALL</p>
                <p>NO COMMITMENT</p>
              </div>
            </FadeIn>
          </div>
          <div className="lg:w-[60%] min-h-[720px] bg-ink rounded-sm border border-hairline flex items-center justify-center overflow-hidden">
            <FadeIn delay={0.2} className="w-full h-full">
              <Cal namespace="30min" calLink="consultantwithabu/30min" style={{width: "100%",height: "720px",overflow: "scroll"}} config={{"layout": "month_view","useSlotsViewOnSmallScreen": "true","theme": "dark"}} />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  );
}